import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { Image3D } from '~/domain/patient/image3d';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import { replanningScansState } from '~/state/atoms/adaptiveReplanningAtoms';
import { findImageBySeriesUid } from '~/hooks/workflows/findImageBySeriesUid';

export interface PlanAndTargetScans {
    readonly source?: Image3D;
    readonly target?: Image3D;
}

// The source and target chosen on Plan & Target.
export function usePlanAndTargetScans(): PlanAndTargetScans {
    const patient = useSelectedPatient();
    const { sourceSeriesUid, targetSeriesUid } =
        useRecoilValue(replanningScansState);
    return useMemo(
        () => ({
            source: findImageBySeriesUid(patient, sourceSeriesUid),
            target: findImageBySeriesUid(patient, targetSeriesUid),
        }),
        [patient, sourceSeriesUid, targetSeriesUid]
    );
}
